import React from 'react'
import styles from './styles'
import formatters from 'lib/formatters'

const FeeSchedule = ({ feeSchedule }) => {
  const normalizedScheduleType = feeSchedule?.toUpperCase()
  const formattedFeeSchedule = formatters.mapFeeSchedule(normalizedScheduleType)
  const displayScheduleName = formatters.legibleFeeSchedule(feeSchedule) || 'Fee Schedule'

  return (
    <div className={`${styles.depositCols} ${styles.feeSchedule}`}>
      <p className={styles.depositLabel}>{displayScheduleName}</p>
      {formattedFeeSchedule?.length > 0 ? (
        formattedFeeSchedule.map((feeItem, index) => (
          <p key={index} className={styles.depositValue}>
            <span className={styles.rate}>{feeItem.rate} </span>
            <span className={styles.descriptionFull}>{feeItem.description}</span>
          </p>
        ))
      ) : (
        <p className={styles.depositValue}>No fee schedule found for {displayScheduleName}</p>
      )}
    </div>
  )
}

export default FeeSchedule
